import React from 'react';
import { formatNumber } from '../../helpers/formatNumber';

export const MapOrdersInfo = ({ orderCount, volumeM3 }) => (
  <div className="d-flex flex-column map-info-box">
    <div className="map-info-box__section-title">{__('routes.visible_map_orders')}</div>
    <div>
      {__('routes.map_points')}: <span data-testid="map-order-count">{orderCount}</span>
    </div>
    <div>
      {__('routes.map_volume')}: <span data-testid="map-order-volume">{formatNumber(volumeM3)}</span>m³
    </div>
  </div>
);
